import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-session-playback-controls',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="absolute bottom-4 left-1/2 -translate-x-1/2 bg-black border border-zaxis-border/80  border border-zaxis-border rounded-none p-3 w-[560px] max-w-[90vw] flex flex-col gap-3 shadow-pixel z-10">
      <div class="relative w-full h-2 bg-white/10 rounded-none cursor-pointer group border border-white/5" (click)="onSeek($event)">
        <div class="absolute top-0 left-0 h-full bg-zaxis-accent transition-all duration-100 rounded-none group-hover:brightness-125" [style.width.%]="progress"></div>
      </div>
      <div class="flex justify-between items-center text-white">
        <span class="text-xs font-mono text-gray-400">{{ formatTime(currentTime) }}</span>
        <div class="flex gap-3 items-center">
          <button (click)="onTogglePlay()" 
                  [disabled]="!sceneReady"
                  [class.opacity-50]="!sceneReady"
                  [class.cursor-not-allowed]="!sceneReady"
                  class="w-10 h-10 flex items-center justify-center bg-transparent border border-zaxis-border hover:bg-white/5 text-xs font-mono uppercase tracking-widest rounded-none transition-colors relative">
            <i *ngIf="!playing && pendingModelDownloads === 0" class="ph-fill ph-play text-xl"></i>
            <i *ngIf="playing && pendingModelDownloads === 0" class="ph-fill ph-pause text-xl"></i>
            <div *ngIf="pendingModelDownloads > 0" class="absolute inset-0 flex items-center justify-center">
              <span class="w-5 h-5 border-2 border-white/30 border-t-white rounded-none animate-spin"></span>
            </div>
          </button>
          <span *ngIf="pendingModelDownloads > 0" class="text-[10px] text-gray-400 font-mono tracking-wide bg-white/5 px-2 py-1 rounded border border-zaxis-border animate-pulse whitespace-nowrap">
            Descargando {{ pendingModelDownloads }} modelo(s)...
          </span>
        </div>
        <span class="text-xs font-mono text-gray-400">{{ formatTime(duration) }}</span>
      </div>
    </div>
  `
})
export class SessionPlaybackControlsComponent {
  @Input() progress: number = 0;
  @Input() currentTime: number = 0;
  @Input() duration: number = 0;
  @Input() playing: boolean = false;
  @Input() sceneReady: boolean = false;
  @Input() pendingModelDownloads: number = 0;

  @Output() seek = new EventEmitter<number>();
  @Output() togglePlay = new EventEmitter<void>();

  onSeek(event: MouseEvent) {
    const bar = event.currentTarget as HTMLElement;
    const rect = bar.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const percent = Math.max(0, Math.min(1, x / rect.width));
    this.seek.emit(percent);
  }

  onTogglePlay() {
    this.togglePlay.emit();
  }

  formatTime(seconds: number): string {
    const ms = seconds * 1000;
    const totalSeconds = Math.floor(ms / 1000);
    const m = Math.floor(totalSeconds / 60);
    const s = totalSeconds % 60;
    const millis = Math.floor((ms % 1000) / 10);
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}.${millis.toString().padStart(2, '0')}`;
  }
}
